import React from 'react';
import { object, string, bool } from 'prop-types';

import { Marker } from 'google-maps-react';

const MarkerCluster = ({ position, google, isCluster, label, ...rest }) => {
  let markerIcon = {
    url: '/assets/pop.svg',
    anchor: new google.maps.Point(10,10),
    scaledSize: new google.maps.Size(20,20)
  };

  if(isCluster) {
    markerIcon = {
      url: '/assets/pop-cluster-60.svg',
      anchor: new google.maps.Point(30,30),
      scaledSize: new google.maps.Size(60,60),
      labelOrigin: new google.maps.Point(75, 29)
    };
  }

  return (
    <Marker
      {...rest}
      google={google}
      position={position}
      icon={markerIcon}
      label={label}
    />
  );
};

MarkerCluster.propTypes = {
  isCluster: bool,
  google: object,
  position: object,
  title: string,
  label: string
};

export default MarkerCluster;



// WEBPACK FOOTER //
// ./src/uis/components/Map/MarkerCluster/MarkerCluster.js